var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreadList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7866 2.33203C16.8266 2.33203 13.6133 5.54536 13.6133 9.50536C13.6133 13.4654 16.8266 16.6787 20.7866 16.6787C24.7466 16.6787 27.9599 13.4654 27.9599 9.50536C27.9599 5.54536 24.7466 2.33203 20.7866 2.33203Z",
    fill: "#DCDBE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48004 17.375C6.04004 17.375 4.04004 19.3617 4.04004 21.815C4.04004 24.2683 6.02671 26.255 8.48004 26.255C10.92 26.255 12.92 24.2683 12.92 21.815C12.92 19.3617 10.92 17.375 8.48004 17.375Z",
    fill: "#DCDBE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1598 22.1602C20.0931 22.1602 18.4131 23.8402 18.4131 25.9068C18.4131 27.9735 20.0931 29.6535 22.1598 29.6535C24.2264 29.6535 25.9064 27.9735 25.9064 25.9068C25.9064 23.8402 24.2264 22.1602 22.1598 22.1602Z",
    fill: "#DCDBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadList);
export default __webpack_public_path__ + "static/media/ThreadList.abcadb65e65e479c757748e01e5d3d47.svg";
export { ForwardRef as ReactComponent };